module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/0-introduction.json
// module id = 330
// module chunks = 22996893160321